import { Platform } from 'react-native'

import * as colors from './colors'
import { BASE } from './spacing'

// Default
export const defaultFontFamily = 'OpenSans-Regular'
export const defaultFontSize = 16
export const defaultLineHeight = BASE
export const defaultFontWeight = '400'

// Demi
export const book =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '400'},
  ios: {fontWeight: '400'},
  android: {fontFamily: 'OpenSans-Light'}
})}

// Medium
export const medium =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '500'},
  ios: {fontWeight: '500'},
  android: {fontFamily: 'OpenSans-Regular'}
})}

// Demi
export const demi =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '600'},
  ios: {fontWeight: '600'},
  android: {fontFamily: 'OpenSans-Regular'}
})}

// Light Bold
export const lightbold =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '700'},
  ios: {fontWeight: '700'},
  android: {fontFamily: 'OpenSans-SemiBold', fontWeight: '700'}
})}

// Bold
export const bold =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '700'},
  ios: {fontWeight: '800'},
  android: {fontFamily: 'OpenSans-Bold'}
})}

// ExtraBold
export const extrabold =
{...Platform.select({
  web: {fontFamily: 'OpenSans-Regular', fontWeight: '700'},
  ios: {fontWeight: '900'},
  android: {fontFamily: 'OpenSans-Bold'}
})}

export function calculateLineHeight(fontSize) {
  return Math.ceil(fontSize / BASE) * 24
}

export const defaultTextStyle = {
  fontFamily: defaultFontFamily,
  fontSize: defaultFontSize,
  fontWeight: defaultFontWeight,
  color: colors.srPlaceholder
}
